import React, { useEffect, useState } from "react";
import {
    Button,
    Typography,
    Box,
    Grid,
    Tooltip,
    Card,
    CardContent,
    IconButton,
    CardActions,
    Divider,
    Skeleton,
    Menu,
    MenuItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from '@mui/icons-material/Edit';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Add } from "@mui/icons-material";
import { NoData } from "../../../Base/views/NotAuthorized";
import { DeleteOfferLetterTemplateAction, GetOfferLetterTemplateAction } from "../../../../../store/ATS/FormTemplate/Action";
import { GetLetterHeadAction } from "../../../../../store/Ancillary/LetterHead/Action";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import history from "../../../../../history";
import { GetOfferLetterTemplateHelper } from "../../helper/AtsFormTemplateHelper";
import { toast } from "react-toastify";
import { parseOfferLetterContent } from "./editor/OfferLetterDocumentEditor";


function OfferLetterTemplates({setCurrentMode, setData}) {
    const dispatch = useDispatch()
    const [formId, setFormId] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const { offerletterData, isLoading } = useSelector((state) => state.AtsReducer?.FormTemplateReducer);
    const { letterHeadData } = useSelector((state) => state.AncillaryReducer?.LetterHeadReducer || {});
    const [deleteConfirm, setDeleteConform] = useState(false);

    useEffect(() => {
        dispatch(GetOfferLetterTemplateAction());
        dispatch(GetLetterHeadAction());
    }, []);

    const handleEdit = (data) => {
        GetOfferLetterTemplateHelper({
            offer_letter_template_id: data?.offer_letter_template_id,
        }).then((res) => {
            const freshData = res?.data?.data?.[0] || data;
            const parsed = parseOfferLetterContent(freshData?.offer_letter_content);
            const activeMode = freshData?.is_letterhead === true
                ? "LETTERHEAD"
                : (freshData?.is_letterhead === false
                    ? "OUR_HEADER_FOOTER"
                    : (parsed?.header_footer_mode || freshData?.header_footer_mode || "OUR_HEADER_FOOTER"));
            setCurrentMode("Edit");
            setData({
                ...freshData,
                header_footer_mode: activeMode,
            });
        });
    }

    const handleDeleteConfirm = (id) => {
        setFormId(id);
        setDeleteConform(!deleteConfirm);
    }

    const handleDelete = () => {
        dispatch(DeleteOfferLetterTemplateAction({ offer_letter_template_id: formId }));
        setFormId("");
        setDeleteConform(!deleteConfirm);
    }
    
    const handleAddWithMode = (mode) => {
        setAnchorEl(null);
        if (mode === "LETTERHEAD") {
            const hasLetterhead = Boolean(letterHeadData?.[0]?.letterhead_file_path || letterHeadData?.[0]?.letterhead_path);
            if (!hasLetterhead) {
                toast.warning("Please configure your company letterhead in Settings first.");
                return;
            }
        }
        setCurrentMode("Add");
        setData({ header_footer_mode: mode });
    };

    return (
        <Box sx={{ maxHeight: "85vh", overflowY: "auto", pb: 2 }}>
           
                <Box sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    backgroundColor: "#ffffff",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 2,
                    paddingRight: "5px"
                }}>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color: "#0854ffcf",
                        fontSize: "14px",
                        fontWeight: 500,
                    }}>
                        <Tooltip title="Configure Letterhead">
                            <div onClick={() => history.push("/settings", { click_event: "4", tabValue: "4" })}>
                                Configure your company letterhead
                            </div>
                        </Tooltip>
                    </Box>
                    <Button
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                        variant="contained"
                        className="mpl-primary-btn"
                        startIcon={<Add />}
                        sx={{ marginBottom: "10px", marginTop:"10px" }}
                    >
                        Add Offer Letter Template
                    </Button>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuItem onClick={() => handleAddWithMode("OUR_HEADER_FOOTER")} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5 }}>
                            <span>Use Configured Header & Footer</span>
                            <Tooltip title="Uses company logo, header title, and footer text configured in settings" arrow>
                                <InfoOutlinedIcon sx={{ fontSize: 16, color: "#64748b" }} />
                            </Tooltip>
                        </MenuItem>
                        <MenuItem onClick={() => handleAddWithMode("LETTERHEAD")} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5 }}>
                            <span>Use Company Letterhead (PDF)</span>
                            <Tooltip title="Uses pre-uploaded official company letterhead PDF document background" arrow>
                                <InfoOutlinedIcon sx={{ fontSize: 16, color: "#64748b" }} />
                            </Tooltip>
                        </MenuItem>
                    </Menu>
                </Box>
                <>
                    {isLoading ? <Grid container direction="row" alignItems="center" spacing={2} mt={1}>
                        {Array(8)
                            .fill()
                            .map((data, index) => (
                                <Grid key={index} item lg={3} md={3} sm={3} xs={12}>
                                    <Card
                                        key={index}
                                        sx={{
                                            ":hover": { cursor: "pointer" },
                                            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                                            minHeight: "125px",
                                            maxHeight: "125px"
                                        }}
                                    >
                                        <CardContent>
                                            <Skeleton
                                                sx={{ height: 40 }}
                                                animation="wave"
                                                variant="rectangular"
                                            />
                                        </CardContent>
                                        <Divider variant="middle" />
                                        <CardActions sx={{ padding: "0px" }}>
                                            <Box
                                                sx={{
                                                    padding: "0px 20px 8px 20px",
                                                    display: "flex",
                                                    WebkitBoxPack: "justify",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                }}
                                            >
                                                <Skeleton
                                                    animation="wave"
                                                    sx={{ borderRadius: 4 }}
                                                    height={20}
                                                    width="30%"
                                                />
                                                <Skeleton
                                                    animation="wave"
                                                    sx={{ borderRadius: 4 }}
                                                    height={20}
                                                    width="30%"
                                                />
                                            </Box>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))}
                    </Grid>
                        :
                        offerletterData?.length > 0 ? <Grid container direction="row" alignItems="center" spacing={2} mt={1}>
                            {offerletterData?.map((template, index) => (
                                <Grid key={index} item lg={3} md={3} sm={3} xs={12} >
                                    <Card key={index} sx={{ ":hover": { cursor: "pointer" }, minHeight: "125px", maxHeight: "125px" }}>
                                        <CardContent>
                                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                <Tooltip title={template?.offer_letter_template_name}>
                                                    <Typography variant="h5" className="truncate-heading">{template?.offer_letter_template_name}</Typography>
                                                </Tooltip>
                                            </Box>
                                        </CardContent>
                                        <Divider variant="middle" />
                                        <CardActions sx={{ padding: "0px" }}>
                                            <Box
                                                sx={{
                                                    padding: "0px 20px 8px 20px",
                                                    display: "flex",
                                                    WebkitBoxPack: "justify",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                }}
                                            >
                                                <Tooltip title="Edit">
                                                    <IconButton onClick={() => handleEdit(template)}>
                                                        <EditIcon color="primary" fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip
                                                    title={
                                                        <Box sx={{ fontSize: "12px", lineHeight: 1.5 }}>
                                                            <Box>• {(template?.is_letterhead === true || template?.header_footer_mode === "LETTERHEAD")
                                                                ? "Uses pre-uploaded official company letterhead PDF document background"
                                                                : "Uses company logo, header title, and footer text configured in settings"}</Box>
                                                            <Box>• {template?.is_configure_ctc === false ? "CTC is not configured" : "CTC is configured"}</Box>
                                                        </Box>
                                                    }
                                                    arrow
                                                    placement="bottom"
                                                >
                                                    <IconButton
                                                        size="small"
                                                        disableRipple
                                                        sx={{
                                                            color: "#64748b",
                                                            "&:hover": {
                                                                backgroundColor: "transparent",
                                                                color: "#64748b",
                                                            },
                                                        }}
                                                    >
                                                        <InfoOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                {
                                                    template?.response_id === null ?
                                                        <Tooltip title={"Delete"}>
                                                            <IconButton onClick={() => handleDeleteConfirm(template?.offer_letter_template_id)}>
                                                                <DeleteIcon color="error" fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        :
                                                        <Tooltip title={"Responses are submitted for this form template. Please create new template."}>
                                                            <IconButton sx={{ color:'grey.500'}}>
                                                                <DeleteIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                }

                                            </Box>
                                        </CardActions>
                                    </Card>
                                </Grid>))}
                        </Grid>
                            : <NoData title="You haven’t created any templates yet" />
                    }
                </>
                
            <ConfirmationDialog
                title="Delete Template?"
                content={"Are you sure want to Delete this Template?"}
                openDialog={deleteConfirm}
                closeDialog={setDeleteConform}
                OkButtonText="OK"
                onSubmit={handleDelete}
            />
        </Box>
    );
}

export default OfferLetterTemplates;